import React, {Component} from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import ColorInput from 'components/ColorInput';
import WebChatDemo from './WebChatDemo';
import Translate from '../../../../../../components/Translate';
import config from '../../../../../../config';
import {silverInfoStyles} from "../../../../../../utils/General";

class WebChatStyles extends Component {
    maxLengths = {
        headerText: 20,
        messageText: 17,
        getStartedText: 25,
        headerBottomText: 17,
        newChatText: 25,
        generateChatHistoryText: 25,
        muteOrUnmuteText: 25,
        screenshotText: 25,
        openNewWindowText: 25,
        input1PlaceholderText: 15,
        input2PlaceholderText: 15,
        input3PlaceholderText: 15,
        input4PlaceholderText: 15,
        inputHeaderText: 50,
        fileSizeErrorNotificationText: 30,
        invalidEmailNotificationText: 30,
        invalidPhoneNumberNotificationText: 30,
    };

    fields = {
        main: ['headerText', 'headerBottomText', 'messageText', 'getStartedText'],
        menu: ['generateChatHistoryText', 'muteOrUnmuteText', 'screenshotText', 'openNewWindowText', 'newChatText'],
        startInputs: ['input1PlaceholderText', 'input2PlaceholderText', 'input3PlaceholderText', 'input4PlaceholderText', 'inputHeaderText'],
        notifications: ['fileSizeErrorNotificationText', 'invalidEmailNotificationText', 'invalidPhoneNumberNotificationText'],
        colors: ['headerBackground', 'botMessageBackground', 'botTextColor', 'userTextColor', 'userMessageBackground', 'quickReplyTextColor', 'bodyBackground', 'footerBackground'],
    };

    saveColor = (position) => (value) => {
        const {saveColors} = this.props;
        const data = {[position]: typeof value === 'object' ? value.target.value : value};
        saveColors(data);
    };

    saveText = (position) => (value) => {
        const {saveTexts} = this.props;
        const textValue = typeof value === 'object' ? value.target.value : value;
        if (textValue.length <= this.maxLengths[position]) {
            const data = {[position]: textValue};
            saveTexts(data);
        }
    };

    renderInputField = (field, value, maxLength, handler, extra = null) => (
        <div key={field} style={{marginBottom: '10px', width: '60%', display: 'flex', gap: '5px', flexDirection: 'column'}}>

            <h2 style={{...silverInfoStyles.info, marginLeft: '0px'}}>
                <Translate text={field}/>
            </h2>

            <div key={field} style={{marginBottom: '10px', width: '100%', display: 'flex', gap: '5px'}}>
                <input
                    style={{
                        width: '100%',
                        padding: '8px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                    }}
                    maxLength={maxLength}
                    name={field}
                    defaultValue={value}
                    onBlur={handler(field)}
                />
                {extra}
            </div>

        </div>
    );

    renderColorTab = () => {
        const {colors} = this.props;
        return (
            <div className="bg-white">
                <div className="configurations-forbidden-words-container">
                    <h2 className="configurations-header">
                        <Translate text="colors"/>
                    </h2>
                    <div style={{display: 'flex', gap: '20px'}}>
                        <div style={{
                            width: '409px',
                            height: '328px',
                            padding: '15px',
                            borderRadius: '10px',
                            boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
                        }}>
                            <WebChatDemo {...colors} />
                        </div>
                        <div>
                            {this.fields.colors.map((color) => (
                                <div key={color} style={{marginBottom: '10px'}}>
                                    <ColorInput value={colors[color]} handleChange={this.saveColor(color)}/>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderMainTab = () => {
        const {
            texts, poweredByConfig, savePoweredByConfig, saveTypingIndicatorConfig, typingIndicatorEnabled, seenIndicatorEnabled, saveSeenIndicatorConfig,
            operatorPhotoInChat, saveOperatorPhotoInChat,
            endButton, saveEndButton
        } = this.props;

        return (
            <div className="bg-white">
                <div className="configurations-forbidden-words-container">
                    <h2 className="configurations-header"><Translate text="main"/></h2>
                    {this.fields.main.map(field =>
                        this.renderInputField(field, texts[field], this.maxLengths[field], this.saveText)
                    )}
                    <br/>
                    <div>
                        <div style={{marginBottom: '20px'}}>
                            <label>
                                <input type="checkbox" checked={operatorPhotoInChat}
                                       onChange={(e) => saveOperatorPhotoInChat(e.target.checked)}/>
                                <span style={{marginLeft: '10px', fontStyle: 'italic'}}><Translate
                                    text={'operatorPhotoInChat'}/></span>
                            </label>
                        </div>
                        <div style={{marginBottom: '20px'}}>
                            <label>
                                <input type="checkbox" checked={endButton}
                                       onChange={(e) => saveEndButton(e.target.checked)}/>
                                <span style={{marginLeft: '10px', fontStyle: 'italic'}}><Translate
                                    text={'endButtonPresence'}/></span>
                            </label>
                        </div>
                        <div style={{marginBottom: '20px'}}>
                            <label>
                                <input type="checkbox" checked={typingIndicatorEnabled}
                                       onChange={(e) => saveTypingIndicatorConfig(e.target.checked)}/>
                                <span style={{marginLeft: '10px', fontStyle: 'italic'}}><Translate
                                    text={'typingIndicatorPresence'}/></span>
                            </label>
                        </div>
                        <div style={{marginBottom: '20px'}}>
                            <label>
                                <input type="checkbox" checked={seenIndicatorEnabled}
                                       onChange={(e) => saveSeenIndicatorConfig(e.target.checked)}/>
                                <span style={{marginLeft: '10px', fontStyle: 'italic'}}><Translate
                                    text={'seenIndicatorPresence'}/></span>
                            </label>
                        </div>
                        <div style={{marginBottom: '20px'}}>
                            <label>
                                <input disabled type="checkbox"
                                       checked={poweredByConfig}
                                    // onChange={(e) => savePoweredByConfig(e.target.checked)} // disabled
                                />
                                <span style={{marginLeft: '10px', fontStyle: 'italic'}}><Translate text={'poweredBy'}/></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    renderMenuTab = () => {
        const {texts, menuItems, saveMenuItemConfig} = this.props;
        return (
            <div className="bg-white">
                <div className="configurations-forbidden-words-container">
                    <h2 className="configurations-header"><Translate text="menu"/></h2>
                    {this.fields.menu.map(field =>
                        this.renderInputField(
                            field,
                            texts[field],
                            this.maxLengths[field],
                            this.saveText,
                            menuItems ? (
                                <input
                                    type="checkbox"
                                    checked={menuItems[field]}
                                    onChange={(e) => saveMenuItemConfig(field, e.target.checked)}
                                />
                            ) : null
                        )
                    )}
                </div>
            </div>
        );
    };

    renderStartInputsTab = () => {
        const {texts, startInputsEnabled, saveStartInputsConfig, startInputs, saveStartInputConfig} = this.props;
        return (
            <div className="bg-white">
                <div className="configurations-forbidden-words-container">
                    <h2 className="configurations-header" style={{display: 'flex', gap: '5px'}}>
                        <Translate text="startInputs"/>
                        <input
                            type="checkbox"
                            checked={startInputsEnabled}
                            onChange={(e) => saveStartInputsConfig(e.target.checked)}
                        />
                    </h2>
                    <br/>
                    {this.fields.startInputs.map(field =>
                        this.renderInputField(field,
                            texts[field],
                            this.maxLengths[field],
                            this.saveText,
                            (field !== "inputHeaderText") ? <input
                                type="checkbox"
                                checked={startInputs[field.replace("PlaceholderText", "")]}
                                onChange={(e) => saveStartInputConfig(field.replace("PlaceholderText", ""), e.target.checked)}
                            /> : null
                        )
                    )}
                </div>
            </div>
        );
    };

    renderNotificationsTab = () => {
        const {texts} = this.props;
        return (
            <div className="bg-white">
                <div className="configurations-forbidden-words-container">
                    <h2 className="configurations-header"><Translate text="notifications"/></h2>
                    {this.fields.notifications.map(field =>
                        this.renderInputField(field, texts[field], this.maxLengths[field], this.saveText)
                    )}
                </div>
            </div>
        );
    };

    render() {
        const {features, activeTab} = this.props;

        return (
            <div>
                {features.includes(config.features.CUSTOMIZE_WEBCHAT_COLORS) && activeTab === 'colors' && this.renderColorTab()}
                {features.includes(config.features.CUSTOMIZE_WEBCHAT) && (
                    <React.Fragment>
                        {activeTab === 'main' && this.renderMainTab()}
                        {activeTab === 'menu' && this.renderMenuTab()}
                        {activeTab === 'startInputs' && this.renderStartInputsTab()}
                        {activeTab === 'notifications' && this.renderNotificationsTab()}
                    </React.Fragment>
                )}
            </div>
        );
    }
}

WebChatStyles.propTypes = {
    commonStyles: PropTypes.object.isRequired,
    colors: PropTypes.object.isRequired,
    texts: PropTypes.object.isRequired,
    saveColors: PropTypes.func.isRequired,
    saveTexts: PropTypes.func.isRequired,
    features: PropTypes.array.isRequired,
    poweredByConfig: PropTypes.bool,
    typingIndicatorEnabled: PropTypes.bool,
    savePoweredByConfig: PropTypes.func,
    saveTypingIndicatorConfig: PropTypes.func,
    operatorPhotoInChat: PropTypes.bool,
    saveOperatorPhotoInChat: PropTypes.func,
    endButton: PropTypes.bool,
    saveEndButton: PropTypes.func,
    startInputsEnabled: PropTypes.bool,
    saveStartInputsConfig: PropTypes.func,
    menuItems: PropTypes.object,
    startInputs: PropTypes.object,
    saveMenuItemConfig: PropTypes.func,
    activeTab: PropTypes.string.isRequired,
};

export default Radium(WebChatStyles);


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/webchat-conf/WebChatStyles.jsx